import * as React from 'react';
import './UnlockUser.scss';
import AccountInfo from '../AccountInfo';
import Button from 'src/components/common/Button';
import Input from 'src/components/common/Input';
import { goToForgot, goToRedirect } from 'src/utils/navigation';
import Loader from 'src/components/common/Loader';
import Alert from 'src/pages/ForgotPasswordView/components/Alert';
import { set } from 'es-cookie';
import UserService from 'src/services/user/userService';
import i18n from 'src/translation/i18n';
interface IChangePasswordProps {
  isLoading: boolean;
  hasError: boolean;
  currentPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
  unlockUserValidation: string;
  onCurrentPasswordChange(value: string): void;
  onNewPasswordChange(value: string): void;
  onNewPasswordRepeatChange(value: string): void;
  onChangePassword(cb?: (result: boolean) => void): void;
  onClearError(): void;
  unlockUser: string;
  onUnlockHandleChange(value: string): void;
}

export function UnlockUser(props: any) {
  const [userid, setUserId] = React.useState(null);
  const [validationMessage, updateValidationMsg] = React.useState(null);
  const [
    unlockUserStatusMessage,
    updateunlockUserStatusMessageMsg
  ] = React.useState(null);
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setUserId(event.target.value as string);
  };
  const closePopup = () => {
    updateunlockUserStatusMessageMsg('');
  };
  const validateUserID = () => {
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (userid === '' || userid === null) {
      updateValidationMsg('Length must be greater then zero');
    } else if (userid.match(format)) {
      updateValidationMsg('Must not contain special characters');
    } else {
      updateValidationMsg('');
      updateunlockUserStatusMessageMsg('');
      const unlockUserStatus = UserService.unlockUser(userid);
      unlockUserStatus.then(res => {
        console.log(res.data.status);
        if (res.data.status === 200) {
          updateunlockUserStatusMessageMsg(
            <Alert type="success" icon="rpds-check-circle" onClose={closePopup}>
              {i18n.t('common.userUnlocked')}
            </Alert>
          );
        } else if (res.data.status === 404) {
          updateunlockUserStatusMessageMsg(
            <Alert type="error" icon="rpds-error" onClose={closePopup}>
              {i18n.t('common.userNotFound')}
            </Alert>
          );
        } else {
          updateunlockUserStatusMessageMsg(
            <Alert type="error" icon="rpds-error" onClose={closePopup}>
              {i18n.t('common.errorOccured')}
            </Alert>
          );
        }
      });
    }
    return validationMessage;
  };
  return (
    <div className="rp-change-password">
      <div className="rp-change-password--content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-8">
              <h1>Unlock Login User</h1>
              <p className="rp-change-password--subtitle">
                Use the form input to unlock your Reliable Parts account.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-4">
              {unlockUserStatusMessage && (
                <div className="user-status-alert">
                  {unlockUserStatusMessage}
                </div>
              )}
            </div>
          </div>

          <div className="row rp-input">
            <div className="col-12 col-md-4">
              <label>User ID</label>
              <input
                className="user-input"
                value={userid}
                onChange={handleChange}
              />
              <div className="rp-input--message">{validationMessage}</div>
              <button
                type="submit"
                className="rp-button primary-button no-icon uppercase no-select unlock-btn"
                onClick={validateUserID}
              >
                Unlock
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
